import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import * as TrackingService from 'common/services/tracking.service';
import { Flex, Padding } from './base/layout-components';
import Icon from './base/Icon';
import MetricsBox from './MetricsBox';
import { TRACKING } from 'common/constants/constants';
import { StyledWidgetHeader } from './base/common-styles';

const MetricsContainer = styled(Flex)`
  min-height: 20rem;
  width: 100%;
`;

const MetricsOverviewContainer = ({
  metrics = [],
  isScoresReady,
  dataCyPrefix = ''
}) => {
  const Metrics = metrics.map((metric, idx) => (
    <MetricsBox
      {...metric}
      key={`metric_${idx.toString()}`}
      dataCyPrefix={dataCyPrefix}
    />
  ));

  return (
    <MetricsContainer items='center'>
      <Padding l='large' b='medium' t='medium' r='large' width='100%'>
        <Flex direction='column'>
          <Flex direction='row-reverse'>
            <Link
              to='/performance'
              onClick={() =>
                TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                  page: TRACKING.PAGES.DASHBOARD,
                  click_type: TRACKING.CLICK.METRICS
                })
              }
            >
              {isScoresReady ? (
                <Icon
                  name='arraw'
                  direction='up-right'
                  size='x-small'
                  color='black'
                />
              ) : null}
            </Link>
          </Flex>

          <StyledWidgetHeader style={{ paddingBottom: '4rem' }}>
            Delivery Pipeline
          </StyledWidgetHeader>

          <Flex direction='row' justify='space-between' items='flex-start'>
            {Metrics}
          </Flex>
        </Flex>
      </Padding>
    </MetricsContainer>
  );
};

export default MetricsOverviewContainer;
